"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArduinoDeviceAdapter = void 0;
const PixelProtocolSerializer_1 = require("./pixelprotocol/PixelProtocolSerializer");
// The Arduino adapter is a very light facade as most of the
// work is done in the serializers and selected transport
// It just provides a nicer more legible API to call.
class ArduinoDeviceAdapter {
    constructor(transport, serializer = new PixelProtocolSerializer_1.PixelProtocolSerializer()) {
        this._transports = Array.isArray(transport) ? transport : [transport];
        this._serializer = serializer;
    }
    sendPixels(payload) {
        const message = this._serializer.serialize(payload);
        this._transports.forEach(t => t.send(message));
    }
    sendText(payload) {
        const message = this._serializer.serialize(payload);
        this._transports.forEach(t => t.send(message));
    }
    sendControlMessage(payload) {
        const message = this._serializer.serialize(payload);
        this._transports.forEach(t => t.send(message));
    }
}
exports.ArduinoDeviceAdapter = ArduinoDeviceAdapter;
//# sourceMappingURL=ArduinoDeviceAdapter.js.map